interface DataPoint { [key: string]: string|number; month: string; }
interface Props { data: DataPoint[]; keys: string[]; colors: string[]; height?: number; }

export default function MiniBarChart({ data, keys, colors, height=140 }: Props) {
  const maxVal = Math.max(...data.flatMap(d => keys.map(k => Number(d[k]) || 0)));
  const barW=16, barGap=3, groupGap=14;
  const groupW = keys.length * (barW + barGap) - barGap + groupGap;
  const totalW = data.length * groupW;

  return (
    <svg width="100%" viewBox={`0 0 ${totalW + 36} ${height + 36}`} style={{ overflow:"visible" }}>
      {data.map((d, di) => (
        <g key={di} transform={`translate(${18 + di * groupW},0)`}>
          {keys.map((k, ki) => {
            const h = maxVal === 0 ? 0 : Math.round((Number(d[k]) / maxVal) * (height - 8));
            return (
              <rect key={k} x={ki*(barW+barGap)} y={height-h} width={barW} height={h}
                rx={3} fill={colors[ki]} opacity={0.85}>
                <title>{k}: {d[k]}</title>
              </rect>
            );
          })}
          <text x={keys.length*(barW+barGap)/2 - barGap/2} y={height+16}
            textAnchor="middle" style={{ fontSize:10, fill:"#94a3b8" }}>{d.month}</text>
        </g>
      ))}
      <line x1={18} y1={height} x2={totalW+18} y2={height} stroke="#e2e8f0" strokeWidth={0.5}/>
    </svg>
  );
}
